import MySodEodHistory from '../../../views/sod-eod/MySodEodHistory.vue'
import TeamSodEodReview from '../../../views/sod-eod/TeamSodEodReview.vue'
import TeamMemberSodEodReport from '../../../views/sod-eod/TeamMemberSodEodReport.vue'

export default [
    {
        path: '/sod-eod/history',
        name: 'MySodEodHistory',
        meta: { layout: 'default' },
        component: MySodEodHistory,
    },
    {
        path: '/sod-eod/team',
        name: 'TeamSodEodReview',
        meta: { layout: 'default', requiresRole: [1, 2, 11], requiresManagesUsers: true },
        component: TeamSodEodReview,
    },
    {
        path: '/sod-eod/team/:userId',
        name: 'TeamMemberSodEodReport',
        meta: { layout: 'default', requiresRole: [1, 2, 11], requiresManagesUsers: true },
        component: TeamMemberSodEodReport,
    },
]
